import React from 'react';

const Member = ({name, avatar}) => {
    return (
        <div className="checkbox-container">
            <img src={avatar} className="team-avater" />
            <p className="label">{name}</p>
          </div>
    );
};

export default Member;